import toast from "react-hot-toast";

const copyToClipboard = (text: string | number | null | undefined) => {
	if (!text) {
		return;
	}
	navigator.clipboard
		.writeText(text.toString())
		.then(() => {
			toast.success("Copied to clipboard!");
		})
		.catch((err: Error) => {
			toast.error("Failed to copy text: " + err);
		});
};

export { copyToClipboard };
